// extracted by mini-css-extract-plugin
export default {"flex":"headline_flex__17FXJ","headline":"headline_headline__3598U"};